<homey-lotteries-dialog-content
  singleDescription="Homey's auto-apply feature submitted applications to the lottery below, based on your saved preferences."
  multipleDescription="Homey's auto-apply feature submitted applications to the lotteries below, based on your saved preferences."
  singleTitle="Auto-applied for this lottery"
  multipleTitle="Auto-applied for these lotteries"
  [closeButton]="closeButton()"
  [notification]="data()"
>
  <ng-template lotteryDialogListItem let-lottery>
    <homey-open-lottery-list-item [noNegativeMargin]="true" [openInPopup]="true" [lottery]="lottery"></homey-open-lottery-list-item>
  </ng-template>
</homey-lotteries-dialog-content>
